// Funciones
import { ROUTES } from '../../../../../const/routes';

/**
 * Assts de los carteles de las temáticas
 * @param {*} scene
 */
export function cargaAssetsCartelesTematica(scene) {
  scene.load.image(
    'cartelTematica1',
    ROUTES.rutaTragamonedasCartelesTematica +
      '/cartelTematica1ProgramacionEstaticoResized.png'
  );

  scene.load.spritesheet(
    'cartelTematica1Animado',
    ROUTES.rutaTragamonedasCartelesTematica +
      '/cartelTematica2ProgramacionAnimadoResized-Sheet.png',
    {
      frameWidth: 474,
      frameHeight: 81,
    }
  );
}
